var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('home-card'),_c('home-offer'),_c('home-identification'),_c('home-internet'),_c('home-features'),_c('home-cms'),_c('home-technologies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }